// extracted by mini-css-extract-plugin
export default {"container":"function-card_container__VFWjo","link":"function-card_link__Kqt3P","description":"function-card_description__mqMnW","title":"function-card_title__DLApG"};